import { render, staticRenderFns } from "./Mannschaft.vue?vue&type=template&id=3a7524f4&scoped=true&"
import script from "./Mannschaft.vue?vue&type=script&lang=js&"
export * from "./Mannschaft.vue?vue&type=script&lang=js&"
import style0 from "./Mannschaft.vue?vue&type=style&index=0&id=3a7524f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7524f4",
  null
  
)

export default component.exports